// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentful-article {
  background-color: #fff;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px; }
  .contentful-article .contentful-article-toolbar .contentful-article-title {
    padding: 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px; }
    .contentful-article .contentful-article-toolbar .contentful-article-title h3 {
      margin-top: 10px; }
  .contentful-article .contentful-article-toolbar .contentful-article-header {
    padding: 10px;
    border-bottom: 1px solid #eee; }
  .contentful-article .contentful-article-toolbar .contentful-article-actions {
    border-top: 1px solid #eee;
    padding: 10px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px; }
`, "",{"version":3,"sources":["webpack://./src/components/contentful/Article.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB,EAAA;EAJpB;IASM,aAAa;IACb,2BAA2B;IAC3B,4BAA4B,EAAA;IAXlC;MAcQ,gBAAgB,EAAA;EAdxB;IAmBM,aAAa;IACb,6BAA6B,EAAA;EApBnC;IAwBM,0BAA0B;IAC1B,aAAa;IAEb,8BAA8B;IAC9B,+BAA+B,EAAA","sourcesContent":[".contentful-article {\n  background-color: #fff;\n  margin-bottom: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n\n  .contentful-article-toolbar {\n\n    .contentful-article-title {\n      padding: 10px;\n      border-top-left-radius: 4px;\n      border-top-right-radius: 4px;\n\n      h3 {\n        margin-top: 10px;\n      }\n    }\n\n    .contentful-article-header {\n      padding: 10px;\n      border-bottom: 1px solid #eee;\n    }\n\n    .contentful-article-actions {\n      border-top: 1px solid #eee;\n      padding: 10px;\n\n      border-bottom-left-radius: 4px;\n      border-bottom-right-radius: 4px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
